import React from 'react';
import {Box} from "@mui/material";
import {useTheme} from "@mui/material/styles";
import useApiGetSchedaCostoDetail from "./api-hooks/useApiGetSchedaCostoDetail";
import LabelledMuiTypography from "../../../../../ui/mui/mui-display-data/LabelledMuiTypography";

interface Props {
    order_id?: number,
}

const SchedaFinalMeasurementCard = ({order_id: order_id}: Props) => {
    const theme = useTheme();
    const fontSize = 18;

    const {data: detailedObj, isSuccess, isFetched} = useApiGetSchedaCostoDetail(order_id);

    return (
        <Box component="fieldset" sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-end',
            border: '1px solid lightgrey',
            borderRadius: '4px',
            padding: '10px',
            backgroundColor: theme.palette.backgroundAppGarageColor.main
        }}>
            <legend style={{
                padding: '0 8px',
                color: theme.palette.primary.main,
                fontWeight: 500
            }}>
                Misura Finale
            </legend>
            <>

                <LabelledMuiTypography
                    label={'Misura Finale '}
                    value={detailedObj?.effective_misura_finale?.toFixed(2) + " mq" ?? ''}
                    upperCaseValue={false}
                    fontSize={fontSize}
                />
                <LabelledMuiTypography
                    label={'Pezzi '}
                    value={detailedObj?.effective_pcs?.toFixed(2) + " pcs" ?? ''}
                    upperCaseValue={false}
                    fontSize={fontSize}
                />
                <LabelledMuiTypography
                    label={'Prezzo vendita '}
                    value={detailedObj?.prezzo_vendita?.toFixed(2) + " €/mq" ?? ''}
                    upperCaseValue={false}
                    fontSize={fontSize}
                />


            </>


        </Box>
    );
}

export default SchedaFinalMeasurementCard;